import React, { PureComponent } from "react";
import Modal from "react-responsive-modal";
import Logbook from "./Logbook.js";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

// import QuickToolbar from "../shared/QuickToolbar";

class LogbookModal extends PureComponent {

  render() {
	  return (
		  <Modal classNames={{
			  overlay: "ambifi-web-player",
			  modal: "player-comments-modal",
			  transitionEnter: "ambifi-web-player-modal-slide-up-enter",
			  transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
			  transitionExit: "ambifi-web-player-modal-slide-up-exit",
			  transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
		  }}
			  open={this.props.isOpen}
			  showCloseIcon={false}
			  onEntered={this.onModalEntered}
			  onClose={() => { }}>			  
			<div style={{ display: "flex", flexDirection: "column", flex: 1, marginTop: 0, marginLeft: 0, marginBottom: 0, marginRight: 0, alignItems: "center", justifyContent: "space-between", backgroundColor: "#00A2F9", width: "100%", height: "100%" }}>
				<div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "center", justifyContent: "space-between", width: "100%", height: "100%" }}>
					<div style={{ marginTop: 5 }}>
						<span style={{ fontSize: 24, color: "white" }}>Clock</span>
					</div>

					<div style={{width: "100%", height: "100%", overflowX:"hidden", overflowY:"auto"}}><Logbook /></div>

					<div style={{ marginBottom: 5 }}>
						<div onClick={this.props.onClickClose} style={{cursor: "pointer"}}>
							<div style={{ fontSize: 20, color: "white" }}><FontAwesomeIcon icon={"chevron-down"} marginLeft={10} size={20} /> GO BACK</div>
						</div>
					</div>
					{/* <QuickToolbar backgroundColor="rgba(0,0,0,.7)"/> */}
				</div>
			  </div>
		</Modal>
	  );
  }
}

export default LogbookModal;